import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, map } from 'rxjs';
import { LessonTab } from '../../core/interfaces/lesson';
import { environment } from 'src/environments/environments';

@Injectable({
  providedIn: 'root'
})
export class TabsService {

  private tabsBaseUrl = environment.tabsBaseUrl;

  constructor(private http: HttpClient) { }

  getAll(): Observable<any[]>{
    return this.http
      .get<any>(this.tabsBaseUrl).pipe(
        map(obs => obs.body.Tabs)
      )
  }

  getOne(id: string): Observable<any> {
    return this.http
      .get<any>(`${this.tabsBaseUrl}/${id}`).pipe(
        map(obs => obs.body.Tab)
      );
  }

  getByLessonId(lessonId: string): Observable<LessonTab[]>{
    return this.http
      .get<any>(`${this.tabsBaseUrl}ByLesson/${lessonId}`).pipe(
        map(obs => {
          const tabs = obs.body.Tabs;
          tabs.sort((a,b) => a.tabOrder - b.tabOrder);
          return tabs;
        }),
      );
  }

  saveAll(tabs: LessonTab[], deletedPages?: number[][]): Observable<any>{
    const observables: Observable<any>[] = [];

    for (const [tabIndex, tab] of tabs.entries()) {
      if (!tab.id) {
        observables.push(this.create(tab));
      }
      observables.push(this.update(tab.id!, tab, deletedPages![tabIndex]));
    }

    return forkJoin(observables);
  }

  // save(tab: LessonTab):Observable<any>{
  //   if (!tab.id) {
  //     return this.create(tab);
  //   }
  //   return this.update(tab.id!, tab);
  // }

  private create(body: LessonTab): Observable<any>{
    return this.http
      .post<any>(this.tabsBaseUrl, body).pipe(
        map(obs => {return {status: obs.status, Tab: obs.body}})
      );
  }

  private update(id: string, body: LessonTab, deletedPages: number[]): Observable<any>{
    return this.http.put<any>(this.tabsBaseUrl+'/'+id, {
      ...body,
      deletedPages
    });
  }

  // delete(id: string): Observable<any> {
  //   return this.http.delete<any>(this.tabsBaseUrl+'/'+id);
  // }
}
